import { BrowserRouter } from 'react-router-dom';
import { Google } from '@widgets';
import { Root } from '@routes';

export const App = () => {
  return (
    <BrowserRouter>
      <Google trackingId='UA-25829125-12' />
      <Root />
    </BrowserRouter>
  );
};
